import { defineStore } from 'pinia'

import type { TutorAttendanceRatesStore } from './interfaces'

import { emptyTutorAttendanceRatesFilters } from '@helpers/tutor-attendance-rates-query'

import { actions } from './actions'
import { getters } from './getters'

export const useTutorAttendanceRatesStore = defineStore('tutor-attendance-rates', {
  state: (): TutorAttendanceRatesStore => ({
    loading: false,
    rates: [],
    totals: null,
    meta: null,
    filters: emptyTutorAttendanceRatesFilters(),
    currentPage: 1,
    perPage: 25,
  }),
  actions,
  getters,
})
